<form nz-form class="form" nzLayout="horizontal">
  <div class="drawer-form-wrapper" #pdfContent>
    <div class="header-with-cta mb-24">
      <h3 class="title s-18" data-pdfmake='{"fontSize": 14, "bold": true}'>
        {{ strategy?.behaviourStrategyTypeName }}
        :
        {{ strategy?.title }}
      </h3>
      <div class="display-flex strategy-actions">
        <div *ngIf="isStrategyId" class="display-flex strategy-actions-view">
          <div
            *ngIf="strategy?.isPublish || strategy?.isRejected"
            class="status"
            [ngClass]="strategy?.isPublish ? 'active' : 'closed'">
            <span>{{ strategy?.isPublish ? 'Approved' : 'Rejected' }}</span>
          </div>
        </div>
        <div
          class="display-flex strategy-actions-view"
          *ngIf="mode === 'view' && !isStrategyId">
          <button
            *ngIf="strategy?.videoUrl"
            nz-button
            type="button"
            nzType="default"
            (click)="openVideoModal()">
            <svg-icon
              [title]="'Play video'"
              src="/assets/icon/icon-play.svg"
              class="icon s-16"
              aria-label="Play"></svg-icon>
          </button>
          <button
            class="no-active"
            nz-button
            type="button"
            nzType="default"
            [title]="
              isStrategyActive ? 'Deactivate strategy' : 'Activate strategy'
            "
            [nzLoading]="loading$ | async"
            (click)="toggleStatus()">
            <svg
              *ngIf="isStrategyActive"
              class="status-icon"
              width="40"
              height="24"
              viewBox="0 0 48 24"
              xmlns="http://www.w3.org/2000/svg">
              <rect rx="12" width="48" height="24" fill="#00E676" />
              <circle cx="36" cy="12" r="8" fill="white" />
              <path
                d="M32 12l3 3 5-5"
                fill="none"
                stroke="#00E676"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <svg
              *ngIf="!isStrategyActive"
              class="status-icon"
              width="40"
              height="24"
              viewBox="0 0 48 24"
              xmlns="http://www.w3.org/2000/svg">
              <rect rx="12" width="48" height="24" fill="#FF1744" />
              <circle cx="12" cy="12" r="8" fill="white" />
              <path
                d="M9 9l6 6M15 9l-6 6"
                stroke="#FF1744"
                stroke-width="2"
                stroke-linecap="round" />
            </svg>
          </button>
          <button
            (click)="openCreateOwnStrategyComponent()"
            nz-button
            type="button"
            nzType="default">
            <svg-icon
              [title]="'Edit Strategy'"
              src="/assets/icon/icon-edit.svg"
              class="icon s-16"
              aria-label="Edit">
            </svg-icon>
          </button>
          <button nz-button type="button" nzType="default" (click)="onDelete()">
            <svg-icon
              [title]="'Delete'"
              src="/assets/icon/icon-trash.svg"
              class="icon s-16"
              aria-label="Trash">
            </svg-icon>
          </button>
        </div>
        <button
          class="no-print"
          nz-button
          type="button"
          nzType="default"
          (click)="getStrategyPdf()">
          <svg-icon
            [title]="'Print Strategy'"
            src="/assets/icon/icon-print.svg"
            class="icon s-16"
            aria-label="Print">
          </svg-icon>
          Print Strategy
        </button>
      </div>
    </div>
    <div *ngIf="strategy?.description" class="desc-wrapper mb-24">
      <h3
        class="title s-16 mb-16"
        data-pdfmake='{"fontSize": 12, "bold": true}'>
        Description
      </h3>
      <p class="form-desc">
        {{ strategy?.description }}
      </p>
    </div>
    <div *ngIf="strategy?.guidelines" class="guidelines-wrapper mb-24">
      <h3
        class="title s-16 mb-16"
        data-pdfmake='{"fontSize": 12, "bold": true}'>
        Guidelines
      </h3>
      <div class="custom-data-wrapper">
        <div class="data" *ngFor="let item of strategy?.guidelines">
          <p class="text">
            {{ item.guideline }}
          </p>
        </div>
      </div>
    </div>
    <div
      *ngIf="hasDetailPromptAnswers || strategy?.details"
      class="desc-wrapper mb-24">
      <h3
        class="title s-16 mb-16"
        data-pdfmake='{"fontSize": 12, "bold": true}'>
        Details
      </h3>

      <ng-container *ngIf="hasDetailPromptAnswers; else plainDetailsTemplate">
        <div class="custom-data-wrapper">
          <div class="data" *ngFor="let answer of sortedDetailPromptAnswers">
            <p class="text mb-6">
              {{ getDetailPromptAnswerQuestion(answer) }}
            </p>
            <p class="form-desc">
              {{ answer.answer }}
            </p>
          </div>
        </div>
      </ng-container>

      <ng-template #plainDetailsTemplate>
        <div class="custom-data-wrapper">
          <div class="data">
            <p class="text">
              {{ strategy?.details }}
            </p>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="drawer-footer with-copyright"></div>
  </div>

  <div class="drawer-footer">
    <div class="footer-left"></div>
    <div class="copyright-content text-center">
      <h4 class="title s-16">
        {{ strategy?.behaviourStrategyTypeName }}
      </h4>
      <div class="copyright">
        &copy; {{ currentYear }} Insights To Behavior
        <svg-icon
          nz-tooltip
          [nzTooltipTitle]="titleTemplate"
          src="/assets/icon/icon-help.svg"
          class="icon s-16 icon-help"
          aria-label="Help">
        </svg-icon>
      </div>
      <ng-template #titleTemplate>
        <p class="tooltip-desc">
          All brand or product and their content mentioned in this product are
          the property, trademark, service mark, or registered trademark of
          their respective holders.
        </p>
        <span *ngIf="caseParams && caseParams.case" class="tooltip-footer">
          Licensed to :
          {{ caseParams.case.student.organizationName }}
        </span>
      </ng-template>
    </div>
    <div class="footer-right">
      <ng-container *ngIf="!isExpired && isStrategyId">
        <button
          *ngIf="!strategy?.isPublish && !strategy?.isRejected"
          nz-button
          type="button"
          nzType="default"
          class="primary-outlined"
          (click)="showApprovalModal(strategyId, true)">
          Approve
        </button>
        <button
          *ngIf="!strategy?.isPublish && !strategy?.isRejected"
          nz-button
          type="button"
          nzType="default"
          class="danger-btn"
          (click)="showApprovalModal(strategyId, false)">
          Reject
        </button>
      </ng-container>
    </div>
  </div>
</form>

<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Behavior Strategy'"
  [message]="confrimDialogMsg"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="isDeleting"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancel()"
  (closed)="handleCancel()">
</app-confirm-dialog>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  [nzClosable]="true"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleDeactivated()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title mb-16">Deactivate Strategy</h3>
      <textarea
        style="min-height: 120px; resize: vertical"
        [(ngModel)]="statusChangeReason"
        placeholder="Enter reason for deactivation"
        class="ant-input"
        rows="4">
      </textarea>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleDeactivated()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        nzType="primary"
        class="btn"
        [nzLoading]="loading$ | async"
        [disabled]="!statusChangeReason.trim()"
        (click)="updateStatus()">
        Deactivate
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isApprovalModalVisible"
  [nzTitle]="approvalModalHeaderTemplate"
  [nzFooter]="approvalModalFooterTemplate"
  [nzClosable]="true"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancel()">
  <ng-template #approvalModalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon" [ngClass]="'modal-icon-' + iconColor">
        <svg-icon
          [src]="
            isApproving
              ? '/assets/icon/icon-check-circle-sm.svg'
              : '/assets/icon/icon-close-case.svg'
          "
          class="icon s-20"
          aria-label="Icon"></svg-icon>
      </div>
      <h3 class="ant-modal-title">
        {{ isApproving ? 'Approve' : 'Reject' }} Strategy
      </h3>
      <textarea
        style="min-height: 120px; resize: vertical"
        [(ngModel)]="approvalComments"
        [placeholder]="
          isApproving ? 'Enter approval comments' : 'Enter rejection reason'
        "
        class="ant-input"
        rows="4">
      </textarea>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #approvalModalFooterTemplate>
    <div class="modal-footer">
      <button
        nz-button
        [nzType]="'primary'"
        class="btn btn-cancel"
        (click)="handleCancel()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        nzType="primary"
        [nzLoading]="loading$ | async"
        [disabled]="!approvalComments.trim()"
        (click)="submitApproval()">
        {{ isApproving ? 'Approve' : 'Reject' }}
      </button>
    </div>
  </ng-template>
</nz-modal>

<app-video-modal [(visible)]="isVideoVisible" [videoUrl]="strategy?.videoUrl">
</app-video-modal>

<ng-template #drawerBehaviorEdit>
  <app-drawer-header
    [title]="'Edit Strategy'"
    subtitle="Strategies"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (drawerClose)="closeManageBehaviorDetails()">
  </app-drawer-header>
</ng-template>
